const REACT_APP_ENDPOINT = "https://utils.wsktm.com:5107/api"
export const REACT_APP_ENDPOINT_ = "https://utils.wsktm.com:5107/"
// const REACT_APP_ENDPOINT = "http://127.0.0.1:5000/api"
// export const REACT_APP_ENDPOINT_ = "http://127.0.0.1:5000/"

export const REACT_APP_ENDPOINT_DASHBOARD = REACT_APP_ENDPOINT + '/dashboard'
export const REACT_APP_ENDPOINT_TRAJET_CAMION = REACT_APP_ENDPOINT + '/trajet' // + /:id/camion
/////////  USERS /////////////
export const REACT_APP_ENDPOINT_AUTHENTIFICATION = REACT_APP_ENDPOINT + '/user/login'
export const REACT_APP_ENDPOINT_LIST_USER = REACT_APP_ENDPOINT + '/user/liste'
export const REACT_APP_ENDPOINT_UPDATE_USER = REACT_APP_ENDPOINT + '/user/update'
export const REACT_APP_ENDPOINT_CREATE_USER = REACT_APP_ENDPOINT + '/user/create'
export const REACT_APP_ENDPOINT_DELETE_USER = REACT_APP_ENDPOINT + '/user/delete'
/////////  PERMISSIONS /////////////
export const REACT_APP_ENDPOINT_CREATE_PERMISSION =  REACT_APP_ENDPOINT + "/user/permissions";
export const REACT_APP_ENDPOINT_LIST_PERMISSION =  REACT_APP_ENDPOINT + "/user/permissions";
export const REACT_APP_ENDPOINT_USER_PERMISSIONS =  REACT_APP_ENDPOINT + "/user";
export const REACT_APP_ENDPOINT_UPDATE_USER_PERMISSIONS =  REACT_APP_ENDPOINT + "/user/permissions"
export const REACT_APP_ENDPOINT_LISTE_AGENCE =  REACT_APP_ENDPOINT + "/agences"

///////////  CHAUFFEURS /////////////
export const REACT_APP_ENDPOINT_LIST_CHAUFFEUR = REACT_APP_ENDPOINT + '/chauffeurs/liste'
export const REACT_APP_ENDPOINT_CREATE_CHAUFFEUR = REACT_APP_ENDPOINT + '/chauffeurs/create'
export const REACT_APP_ENDPOINT_UPDATE_CHAUFFEUR = REACT_APP_ENDPOINT + '/chauffeurs/update'
export const REACT_APP_ENDPOINT_DELETE_CHAUFFEUR = REACT_APP_ENDPOINT + '/chauffeurs/delete'
export const REACT_APP_ENDPOINT_ADD_OBSERVATION = REACT_APP_ENDPOINT + '/chauffeurs/observation'
export const REACT_APP_ENDPOINT_LIST_OBSERVATION = REACT_APP_ENDPOINT + '/chauffeurs/observation/'
export const REACT_APP_ENDPOINT_EXPORT_OBSERVATION = REACT_APP_ENDPOINT + '/chauffeurs/observation/export/'
////////// ENERGIE ///////////
export const REACT_APP_ENDPOINT_LIST_ENERGIE = REACT_APP_ENDPOINT + '/energie/liste'
////////// REGION ///////////
export const REACT_APP_ENDPOINT_LIST_REGION = REACT_APP_ENDPOINT + '/region/liste'
export const REACT_APP_ENDPOINT_CREATE_REGION = REACT_APP_ENDPOINT + '/region/create'
export const REACT_APP_ENDPOINT_UPDATE_REGION = REACT_APP_ENDPOINT + '/region/update'
export const REACT_APP_ENDPOINT_DELETE_REGION = REACT_APP_ENDPOINT + '/region/delete'
export const REACT_APP_ENDPOINT_CARBURANT_CONFIG = REACT_APP_ENDPOINT + '/region/carburant/config'

////////// APPARTENANCE ///////////
export const REACT_APP_ENDPOINT_LIST_APPARTENANCE = REACT_APP_ENDPOINT + '/appartenance/liste'
////////// MAINTENANCE ///////////
export const REACT_APP_ENDPOINT_LIST_MAINTENANCE = REACT_APP_ENDPOINT + '/maintenance/liste'
export const REACT_APP_ENDPOINT_LIST_MAINTENANCE_ENTRETIEN = REACT_APP_ENDPOINT + '/maintenance/entretien'
export const REACT_APP_ENDPOINT_CREATE_MAINTENANCE = REACT_APP_ENDPOINT + '/maintenance/create'
////////// STATUT ///////////
export const REACT_APP_ENDPOINT_LIST_STATUT = REACT_APP_ENDPOINT + '/statut/liste'
////////// ENTRETIEN ///////////
export const REACT_APP_ENDPOINT_CREATE_ENTRETIEN = REACT_APP_ENDPOINT + '/entretien/create'
export const REACT_APP_ENDPOINT_LIST_ENTRETIEN = REACT_APP_ENDPOINT + '/entretien/liste'
////////// TYPE ///////////
export const REACT_APP_ENDPOINT_LIST_TYPE = REACT_APP_ENDPOINT + '/type/liste'
export const REACT_APP_ENDPOINT_UPDATE_TYPE = REACT_APP_ENDPOINT + '/type/update'
export const REACT_APP_ENDPOINT_CREATE_TYPE = REACT_APP_ENDPOINT + '/type/create'
export const REACT_APP_ENDPOINT_DELETE_TYPE = REACT_APP_ENDPOINT + '/type/delete'

////////// SITE ///////////
export const REACT_APP_ENDPOINT_LIST_SITE = REACT_APP_ENDPOINT + '/site/liste'
export const REACT_APP_ENDPOINT_CREATE_SITE = REACT_APP_ENDPOINT + '/site/create'
export const REACT_APP_ENDPOINT_UPDATE_SITE = REACT_APP_ENDPOINT + '/site/update'
export const REACT_APP_ENDPOINT_DELETE_SITE = REACT_APP_ENDPOINT + '/site/delete'

////////// CAMION ///////////
export const REACT_APP_ENDPOINT_LIST_CAMION = REACT_APP_ENDPOINT + '/camion/liste'
export const REACT_APP_ENDPOINT_CREATE_CAMION = REACT_APP_ENDPOINT + '/camion/create'
export const REACT_APP_ENDPOINT_UPDATE_CAMION = REACT_APP_ENDPOINT + '/camion/update'
export const REACT_APP_ENDPOINT_DISABLE_CAMION = REACT_APP_ENDPOINT + '/camion/delete'
export const REACT_APP_ENDPOINT_EXPORT_CAMION = REACT_APP_ENDPOINT + '/camion/export'
export const REACT_APP_ENDPOINT_LOCALISATION_CAMION = REACT_APP_ENDPOINT + '/camion/location/all'
export const REACT_APP_ENDPOINT_ADD_CALLIBRAGE_CAMION = REACT_APP_ENDPOINT + '/camion/callibrage/add'


////////// TRAJET ///////////
export const REACT_APP_ENDPOINT_LIST_TRAJET= REACT_APP_ENDPOINT + '/trajet/liste'
export const REACT_APP_ENDPOINT_CREATE_TRAJET = REACT_APP_ENDPOINT + '/trajet/create'
export const REACT_APP_ENDPOINT_UPDATE_TRAJET = REACT_APP_ENDPOINT + '/trajet/update'
export const REACT_APP_ENDPOINT_DISABLE_TRAJET = REACT_APP_ENDPOINT + '/trajet/delete'
export const REACT_APP_ENDPOINT_CREATE_HISTORIQUE_TRAJET = REACT_APP_ENDPOINT + '/historique/create'

////////// CLIENTS ///////////
export const REACT_APP_ENDPOINT_LIST_CLIENTS = REACT_APP_ENDPOINT + "/clients/liste";
export const REACT_APP_ENDPOINT_CLIENTS = REACT_APP_ENDPOINT + "/clients/create"; 
export const REACT_APP_ENDPOINT_UPDATE_CLIENTS = REACT_APP_ENDPOINT + "/clients/update"; 

export const REACT_APP_ENDPOINT_CREATE_DEVIS = REACT_APP_ENDPOINT + "/devis/create"; 
export const REACT_APP_ENDPOINT_CREATE_DEVIS_BENNES = REACT_APP_ENDPOINT + "/devis/create/benne"; 

export const REACT_APP_ENDPOINT_MERGE_DEVIS = REACT_APP_ENDPOINT + "/devis/merge"; 
export const REACT_APP_ENDPOINT_LISTE_DEVIS = REACT_APP_ENDPOINT + "/devis/liste"; 
export const REACT_APP_ENDPOINT_DUPLICATE_DEVIS = REACT_APP_ENDPOINT + "/devis/duplicate/"; 
export const REACT_APP_ENDPOINT_GET_DEVIS = REACT_APP_ENDPOINT + "/devis/"; 
export const REACT_APP_ENDPOINT_UPDATE_DEVIS = REACT_APP_ENDPOINT + "/devis/update/"; 

export const REACT_APP_ENDPOINT_TOGGLE_DEVIS = REACT_APP_ENDPOINT + "/devis/toggle/"; 
export const REACT_APP_ENDPOINT_DOWNLOAD_DEVIS = REACT_APP_ENDPOINT + "/devis/download/"; 
export const REACT_APP_ENDPOINT_EXPORT_DEVIS = REACT_APP_ENDPOINT + "/devis/export"; 

////////// PROVISION ///////////
export const REACT_APP_ENDPOINT_CREATE_PROVISION = REACT_APP_ENDPOINT + '/provision/create'
export const REACT_APP_ENDPOINT_LISTE_PROVISION = REACT_APP_ENDPOINT + '/provision/liste'
export const REACT_APP_ENDPOINT_DOWNLOAD_PROVISION = REACT_APP_ENDPOINT + '/provision/download/'
export const REACT_APP_ENDPOINT_LISTE_MARCHANDISE = REACT_APP_ENDPOINT + '/provision/marchandises'
////////// TRANSIT DOSSIER ///////////
export const REACT_APP_ENDPOINT_CREATE_PROVISION_DOSSIER = REACT_APP_ENDPOINT + '/provision/dossier/create'
export const REACT_APP_ENDPOINT_UPDATE_PROVISION_DOSSIER = REACT_APP_ENDPOINT + '/provision/dossier/update/'
export const REACT_APP_ENDPOINT_TOGGLE_PROVISION_DOSSIER = REACT_APP_ENDPOINT + '/provision/dossier/statut/'

export const REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT = REACT_APP_ENDPOINT + '/provision/document/liste'
export const REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT_ATTACH = REACT_APP_ENDPOINT + '/provision/document/upload'
export const REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT_DOWNLOAD = REACT_APP_ENDPOINT + '/provision/document/download/'

export const REACT_APP_ENDPOINT_GET_PROVISION_DOSSIER = REACT_APP_ENDPOINT + '/provision/dossier/liste'
export const REACT_APP_ENDPOINT_GET_PROVISION_CATEGORIES = REACT_APP_ENDPOINT + '/provision/categories/liste'


export const REACT_APP_ENDPOINT_CREATE_DEVIS_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/devis'
export const REACT_APP_ENDPOINT_UPDATE_DEVIS_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/devis/update'
export const REACT_APP_ENDPOINT_UPDATE_STATUT_DEVIS_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/devis/toggle'

export const REACT_APP_ENDPOINT_GET_DEVIS_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/devis/liste'
export const REACT_APP_ENDPOINT_DOWNLOAD_DEVIS_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/devis/download'
export const REACT_APP_ENDPOINT_DOWNLOAD_FACTURE_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/facture/download' 
export const REACT_APP_ENDPOINT_FACTURE_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/facture'
export const REACT_APP_ENDPOINT_TOGGLE_FACTURE_TRANSIT = REACT_APP_ENDPOINT + '/provision/dossier/facture/toggle'


////////// FACTURES ///////////
export const REACT_APP_ENDPOINT_CREATE_FACTURE = REACT_APP_ENDPOINT + '/factures/create'
export const REACT_APP_ENDPOINT_LISTE_FACTURE = REACT_APP_ENDPOINT + '/factures/liste'
export const REACT_APP_ENDPOINT_DOWNLOAD_FACTURE = REACT_APP_ENDPOINT + '/factures/download/'
export const REACT_APP_ENDPOINT_TOGGLE_FACTURE = REACT_APP_ENDPOINT + "/factures/toggle/"; 
export const REACT_APP_ENDPOINT_ADD_ACOMPTE = REACT_APP_ENDPOINT + "/factures/acompte/"; 
export const REACT_APP_ENDPOINT_LISTE_ACOMPTE = REACT_APP_ENDPOINT + "/factures/acompte/liste"; 
export const REACT_APP_ENDPOINT_EXPORT_FACTURES = REACT_APP_ENDPOINT + "/factures/export"; 
export const REACT_APP_ENDPOINT_LISTE_FACTURE_ECHEANCES = REACT_APP_ENDPOINT + '/factures/echeances/liste'
////////// COMMANDES ///////////
export const REACT_APP_ENDPOINT_CREATE_COMMANDE = REACT_APP_ENDPOINT + '/commande/create'
export const REACT_APP_ENDPOINT_CREATE_COMMANDE_ADDITIONAL = REACT_APP_ENDPOINT + '/commande/additional/create'

export const REACT_APP_ENDPOINT_LISTE_COMMANDE = REACT_APP_ENDPOINT + '/commande/liste'
export const REACT_APP_ENDPOINT_GET_COMMANDE = REACT_APP_ENDPOINT + "/commande/"; 
export const REACT_APP_ENDPOINT_DOWNLOAD_COMMANDE = REACT_APP_ENDPOINT + "/commande/download/"; 
export const REACT_APP_ENDPOINT_UPDATE_COMMANDE = REACT_APP_ENDPOINT + "/commande/update/"; 
export const REACT_APP_ENDPOINT_TOGGLE_COMMANDE = REACT_APP_ENDPOINT + "/commande/toggle/"; 
export const REACT_APP_ENDPOINT_MOBILE_COMMANDE = REACT_APP_ENDPOINT + "/commande/upload"; 
export const REACT_APP_ENDPOINT_EXPORT_COMMANDE = REACT_APP_ENDPOINT + "/commande/export"; 


// -------------------- Articles --------------------
export const REACT_APP_ENDPOINT_LIST_ARTICLES = REACT_APP_ENDPOINT + "/article/liste";
export const REACT_APP_ENDPOINT_GET_ARTICLE = REACT_APP_ENDPOINT +"/article"; // + /:id
export const REACT_APP_ENDPOINT_CREATE_ARTICLE = REACT_APP_ENDPOINT +"/article/add";
export const REACT_APP_ENDPOINT_UPDATE_ARTICLE = REACT_APP_ENDPOINT +"/article/update"; // + /:id
export const REACT_APP_ENDPOINT_DELETE_ARTICLE = REACT_APP_ENDPOINT +"/article/delete"; // + /:id

// -------------------- États --------------------
export const REACT_APP_ENDPOINT_LIST_ETATS = REACT_APP_ENDPOINT +"/etat/liste";
export const REACT_APP_ENDPOINT_CREATE_ETAT = REACT_APP_ENDPOINT +"/etat/add";
export const REACT_APP_ENDPOINT_UPDATE_ETAT = REACT_APP_ENDPOINT +"/etat/update"; // + /:id
export const REACT_APP_ENDPOINT_DELETE_ETAT = REACT_APP_ENDPOINT +"/etat/delete"; // + /:id

// -------------------- Catégories --------------------
export const REACT_APP_ENDPOINT_LIST_CATEGORIES = REACT_APP_ENDPOINT +"/categorie/liste";
export const REACT_APP_ENDPOINT_CREATE_CATEGORIE =REACT_APP_ENDPOINT + "/categorie/add";
export const REACT_APP_ENDPOINT_UPDATE_CATEGORIE =  REACT_APP_ENDPOINT +"/categorie/update"; // + /:id
export const REACT_APP_ENDPOINT_DELETE_CATEGORIE = REACT_APP_ENDPOINT +"/categorie/delete"; // + /:id

// -------------------- Emplacements --------------------
export const REACT_APP_ENDPOINT_LIST_EMPLACEMENTS = REACT_APP_ENDPOINT + "/emplacement/liste";
export const REACT_APP_ENDPOINT_CREATE_EMPLACEMENT = REACT_APP_ENDPOINT +"/emplacement/add";
export const REACT_APP_ENDPOINT_UPDATE_EMPLACEMENT = REACT_APP_ENDPOINT + "/emplacement/update"; // + /:id
export const REACT_APP_ENDPOINT_DELETE_EMPLACEMENT = REACT_APP_ENDPOINT + "/emplacement/delete"; // + /:id

// -------------------- Mouvements de stock --------------------
export const REACT_APP_ENDPOINT_LIST_MOUVEMENTS = REACT_APP_ENDPOINT +"/mouvement/liste";
export const REACT_APP_ENDPOINT_CREATE_MOUVEMENT = REACT_APP_ENDPOINT +"/mouvement/add";
export const REACT_APP_ENDPOINT_UPDATE_MOUVEMENT = REACT_APP_ENDPOINT +"/mouvement/update"; // + /:id
export const REACT_APP_ENDPOINT_DELETE_MOUVEMENT = REACT_APP_ENDPOINT + "/mouvement/delete"; // + /:id

///////// PROSPECTIONS ///////////
export const REACT_APP_ENDPOINT_LIST_PROSPECTION =  REACT_APP_ENDPOINT + "/prospection/liste";
export const REACT_APP_ENDPOINT_CREATE_PROSPECTION =  REACT_APP_ENDPOINT + "/prospection";
export const REACT_APP_ENDPOINT_UPDATE_STATUS_PROSPECTION =  REACT_APP_ENDPOINT + "/prospection"; // /:id/status
export const REACT_APP_ENDPOINT_CREATE_RELANCE =  REACT_APP_ENDPOINT + "/prospection"; // /:id/relance
export const REACT_APP_ENDPOINT_HISTORIQUE_PROSPECTION =  REACT_APP_ENDPOINT + "/prospection"; // /:id/historique

export const REACT_APP_ENDPOINT_UPDATE_PROSPECTION =  REACT_APP_ENDPOINT + "/prospection/";

// =========================
// CAISSES
// =========================

export const REACT_APP_ENDPOINT_GET_CAISSE =
  REACT_APP_ENDPOINT + "/caisses";

export const REACT_APP_ENDPOINT_CREATE_CAISSE =
  REACT_APP_ENDPOINT + "/caisses";

export const REACT_APP_ENDPOINT_DASHBOARD_CAISSE =
  REACT_APP_ENDPOINT + "/caisses"; // + /:id/dashboard


// =========================
// DEPARTEMENTS
// =========================

export const REACT_APP_ENDPOINT_DEPARTEMENT_CAISSE =
  REACT_APP_ENDPOINT + "/departements";

export const REACT_APP_ENDPOINT_CREATE_DEPARTEMENT_CAISSE =
  REACT_APP_ENDPOINT + "/departements";

export const REACT_APP_ENDPOINT_UPDATE_DEPARTEMENT_CAISSE =
  REACT_APP_ENDPOINT + "/departements"; // + /:id

export const REACT_APP_ENDPOINT_DELETE_DEPARTEMENT_CAISSE =
  REACT_APP_ENDPOINT + "/departements"; // + /:id

export const REACT_APP_ENDPOINT_CATEGORIE_CAISSE =
  REACT_APP_ENDPOINT + "/categories";
// =========================
// MODES DE PAIEMENT
// =========================

export const REACT_APP_ENDPOINT_MODES_PAIEMENT =
  REACT_APP_ENDPOINT + "/modes-paiement";


// =========================
// MOUVEMENTS
// =========================

export const REACT_APP_ENDPOINT_GET_MOUVEMENTS_CAISSE = REACT_APP_ENDPOINT + "/caisse/mouvement/mouvements";

export const REACT_APP_ENDPOINT_CREATE_MOUVEMENT_CAISSE = REACT_APP_ENDPOINT + "/caisse/mouvement/mouvements";

export const REACT_APP_ENDPOINT_DELETE_MOUVEMENT_CAISSE = REACT_APP_ENDPOINT + "/caisse/mouvement/mouvements"; // + /:id

export const REACT_APP_ENDPOINT_ADDPJ_MOUVEMENT_CAISSE = REACT_APP_ENDPOINT + "/caisse/mouvement/update/"; // + /:id

export const REACT_APP_ENDPOINT_EXPORT_MOUVEMENT_CAISSE = REACT_APP_ENDPOINT + "/caisse/mouvement/export";

export const REACT_APP_ENDPOINT_EXPORT_MOUVEMENT_PJ = REACT_APP_ENDPOINT + '/caisse/mouvement/mouvements';


export const REACT_APP_ENDPOINT_CONSOMMATION_CARBURANT = REACT_APP_ENDPOINT + '/dashboard/consommation-carburant'
export const REACT_APP_ENDPOINT_CONSOMMATION_CARBURANT_EXPORT = REACT_APP_ENDPOINT + '/dashboard/consommation-carburant/export'